import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import ErrorBoundary from "./components/ErrorBoundary";
import Nav from "./components/Nav";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import Story from "./components/Story";
import Support from "./components/Support";
import Compare from "./components/Compare";
import Calculator from "./components/Calculator";
import Stories from "./components/Stories";
import Team from "./components/Team";
import WhyJoin from "./components/WhyJoin";
import FAQ from "./components/FAQ";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import StickyCTA from "./components/StickyCTA";
import FranchiseAlternative from "./pages/FranchiseAlternative";
import BusinessSupport from "./pages/BusinessSupport";
import { Seo } from "./components/Seo";
import { initLenis, scrollToId } from "./lib/scroll";
import { initTracking } from "./lib/tracking";

function HashScroll() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => scrollToId(hash.replace("#", "")), 600);
      return () => clearTimeout(t);
    }
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function Home() {
  return (
    <>
      <Seo
        title="Build Your Own Real Estate Business | Agency HQ"
        description="Retain up to 95% commission, keep your own brand and get full operational support — Agency HQ is the real estate franchise alternative Australia-wide."
        path="/"
      />
      <main>
        <Hero />
        <Marquee />
        <Story />
        <Support />
        <Compare />
        <Calculator />
        <Stories />
        <Team />
        <WhyJoin />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <StickyCTA />
    </>
  );
}

function App() {
  useEffect(() => {
    initTracking();
    initLenis();
  }, []);

  return (
    <HelmetProvider>
      <ErrorBoundary>
        <BrowserRouter>
          <HashScroll />
          <div className="grain min-h-screen bg-ink text-white">
            <Nav />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/real-estate-franchise-alternative" element={<FranchiseAlternative />} />
              <Route path="/real-estate-business-support" element={<BusinessSupport />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </div>
        </BrowserRouter>
      </ErrorBoundary>
    </HelmetProvider>
  );
}

export default App;
